var router = new VueRouter({
    mode: 'history',
    routes: []
});

function listing() {
    new Vue({
        router,
        el: '#listing',
        data: {
            noData: translation.noData,
            all: translation.all,
            workTypeId: '',
            workYearId: '',
            workAuthorId: '',
            workTypeName: {value: '', label: translation.filtWorkType},
            workYearName: {value: '', label: translation.filtWorkYear},
            workAuthorName: {value: '', label: translation.filtWorkAuthor},
            studioLocationName: {value: '', label: translation.filtStudioLocation},
            studioYearName: {value: '', label: translation.filtStudioYear},
            studioAuthorName: {value: '', label: translation.filtStudioAuthor},
            termOne: '',
            termTwo: '',
            termThree: '',
            posts: [],
            hasPosts: 1,
            apiUrl: '/../wp-json/cck/posts',
            nextPageExists: false,
            paged: 1,
            CheckIntervalSize: 2000, // რამდენ მილიწამში ერთხელ უნდა შემოწმდეს სქროლის მნიშვნელობა.
            showPlaceholderBack: 0,
            interval: 0,
            postType: 'post',
            filterItemIndex: 0,
            apiLang: '',
        },
        components: {
            'v-select': VueSelect.VueSelect,
        },
        watch: {
            workTypeName: function (newValue, oldValue) {

                if (newValue) {
                    this.termOne = 'work_type__' + newValue.value;
                } else {
                    this.termOne = '';
                }

                this.resetRequestData();

            },
            workYearName: function (newValue, oldValue) {

                if (newValue) {
                    this.termTwo = 'work_year__' + newValue.value;
                } else {
                    this.termTwo = '';
                }

                this.resetRequestData();

            },
            workAuthorName: function (newValue, oldValue) {

                if (newValue) {
                    this.termThree = 'work_author__' + newValue.value;
                } else {
                    this.termThree = '';
                }

                this.resetRequestData();

            },
            studioLocationName: function (newValue, oldValue) {

                if (newValue) {
                    this.termOne = 'studio_location__' + newValue.value;
                } else {
                    this.termOne = '';
                }

                this.resetRequestData();

            },
            studioYearName: function (newValue, oldValue) {

                if (newValue) {
                    this.termTwo = 'studio_year__' + newValue.value;
                } else {
                    this.termTwo = '';
                }

                this.resetRequestData();

            },
            studioAuthorName: function (newValue, oldValue) {

                if (newValue) {
                    this.termThree = 'studio_author__' + newValue.value;
                } else {
                    this.termThree = '';
                }

                this.resetRequestData();

            },
        },
        methods: {
            resetRequestData() {
                clearInterval(this.interval);
                this.posts = [];
                this.hasPosts = 1;
                this.nextPageExists = false;
                this.paged = 1;

                this.RequestPosts();
                this.interval = setInterval(function () {
                    this.CheckScrollCondition();
                }.bind(this), this.CheckIntervalSize);
            },
            filterItems(items, start, numberOfItems = 3) {
                let tp_start = start * numberOfItems;

                return items.length >= tp_start
                    ? [items.slice(tp_start, tp_start + numberOfItems)]
                    : [];
            },
            setFilterItemIndex(index = 3) {
                this.filterItemIndex = index;
            },
            SetInfiniteScrollInterval() {
                this.interval = setInterval(function () {
                    this.CheckScrollCondition();
                }.bind(this), this.CheckIntervalSize);
            },
            CheckScrollCondition() {
                let scrollIndexers = document.getElementsByClassName('scrollIndexer');

                if (scrollIndexers.length != 0) {
                    let lastScrollIndexer = scrollIndexers[document.getElementsByClassName('scrollIndexer').length - 1];

                    if (window.pageYOffset + window.innerHeight > lastScrollIndexer.offsetTop && this.nextPageExists != false) // ვამოწმებთ კლიენტმა დასქროლა თუ არა && წამოვიღეთ თუ არა ყველა მონაცემი ბაზიდან
                        this.RequestPosts();
                    else if (this.nextPageExists == false)
                        clearInterval(this.interval);
                }
            },
            RequestPosts: function () {
                $.ajax({
                    url: this.apiUrl,
                    method: 'GET',
                    data: {
                        'paged': this.paged,
                        'posts_type': this.postType,
                        'lang': this.apiLang,
                        'termOne': this.termOne,
                        'termTwo': this.termTwo,
                        'termThree': this.termThree,
                    },
                    beforeSend: function () {
                        this.showPlaceholderBack = 1;
                    }.bind(this),
                    success: function (result) {
                        if (result.post_count > 0) {
                            this.nextPageExists = (result.count_pages > this.paged) ? true : false;
                            this.paged++;
                            this.showPlaceholderBack = 0;

                            let tmp_posts = this.posts;
                            let value = {};
                            $.each(result.posts, function (key, value) {
                                tmp_posts.push(value);
                            });

                            this.posts = tmp_posts;
                        }
                        else {
                            if (this.posts.length == 0)
                                this.hasPosts = -1;
                            this.showPlaceholderBack = 0;
                        }
                    }.bind(this)
                });
            },
            getAuthorIdFromStudents: function () {
                let authorId = this.$route.query.student_id;

                if (authorId) {
                    let authorName = this.$route.query.student_name;
                    this.workAuthorName = {value: authorId, label: authorName};
                    this.termThree = 'work_author__' + authorId;

                    return 1;
                }
                return 0;
            },
        },
        computed: {
            setPostType: function () {

                this.postType = this.$el.getAttribute('data-post-type');

            },
            setAppLang: function () {

                this.apiLang = this.$el.getAttribute('data-api-lang');

            },
            postsCount() {

                return Math.ceil(this.posts.length / 3);

            }

        },
        mounted: function () {
            this.setPostType;
            this.setAppLang;
            var isFromStudents = this.getAuthorIdFromStudents();

            if (!isFromStudents)
                this.RequestPosts();
            this.SetInfiniteScrollInterval();
        }
    });
}


function searchPage() {
    new Vue({
        router,
        el: '#search-page',
        data: {
            posts: [],
            hasPosts: 1,
            apiUrl: '/../wp-json/cck/search',
            nextPageExists: false,
            paged: 1,
            CheckIntervalSize: 2000, // რამდენ მილიწამში ერთხელ უნდა შემოწმდეს სქროლის მნიშვნელობა.
            showPlaceholderBack: 0,
            interval: 0,
            apiLang: '',
            search_query: '',
        },
        methods: {
            resetRequestData(event) {
                if(event.keyCode == 13)
                    event.preventDefault();
                if(event === 'click' || event.keyCode == 13)
                {
                    let searchPageInput = document.getElementById('searchPageInput').value;
                    let urlParam = '?s=' + searchPageInput;
                    this.setAppLang;

                    if (window.history.pushState) {
                        window.history.replaceState(
                            {id: 'searchPage'},
                            null,
                            urlParam
                        );
                        // this.$router.push({ path: 'home' });
                        this.search_query = searchPageInput;
                    }
                    else if (window.location) {
                        window.location = urlParam;
                        this.search_query = searchPageInput;
                    }

                    clearInterval(this.interval);
                    this.hasPosts = 1;
                    this.posts = [];
                    this.nextPageExists = false;
                    this.paged = 1;

                    this.RequestPosts();
                    this.SetInfiniteScrollInterval();
                }
            },
            SetInfiniteScrollInterval() {
                this.interval = setInterval(function () {
                    this.CheckScrollCondition();
                }.bind(this), this.CheckIntervalSize);
            },
            CheckScrollCondition() {
                let scrollIndexers = document.getElementsByClassName('scrollIndexer');

                if (scrollIndexers.length != 0) {
                    let lastScrollIndexer = scrollIndexers[document.getElementsByClassName('scrollIndexer').length - 1];

                    if (window.pageYOffset + window.innerHeight > lastScrollIndexer.offsetTop && this.nextPageExists != false) // ვამოწმებთ კლიენტმა დასქროლა თუ არა && წამოვიღეთ თუ არა ყველა მონაცემი ბაზიდან
                        this.RequestPosts();
                    else if (this.nextPageExists == false)
                        clearInterval(this.interval);
                }
            },
            RequestPosts() {
                $.ajax({
                    url: this.apiUrl,
                    method: 'GET',
                    data: {
                        'paged': this.paged,
                        'lang': this.apiLang,
                        's': this.search_query,
                    },
                    beforeSend: function () {
                        this.showPlaceholderBack = 1;
                    }.bind(this),
                    success: function (result) {
                        if (result.posts.length > 0) {
                            this.nextPageExists = (result.count_pages > result.paged) ? true : false;
                            this.paged++;
                            this.showPlaceholderBack = 0;

                            let tmp_posts = this.posts;

                            let value = {};
                            $.each(result.posts, function (key, value) {
                                tmp_posts.push(value);
                            });

                            this.posts = tmp_posts;
                        }
                        else {
                            if (this.posts.length == 0)
                                this.hasPosts = -1;
                            this.showPlaceholderBack = 0;
                        }
                    }.bind(this)
                });
            },
            setSearchQuery: function () {
                let search_query = this.$route.query.s;

                if (search_query)
                    this.search_query = search_query;
            },
        },
        computed: {
            setAppLang: function() {

                this.apiLang = this.$el.getAttribute('data-api-lang');

            },
        },
        mounted() {
            this.setAppLang;
            this.setSearchQuery();

            this.RequestPosts();
            this.SetInfiniteScrollInterval();
        }
    });
}


{
    if (document.getElementById('listing'))
        listing();
    else if (document.getElementById('search-page'))
        searchPage();
}
